"use client";

import { useQuery } from "@tanstack/react-query";

import { getCurrentUser, getMyCommunities } from "@/lib/feed/api";
import { queryKeys } from "@/lib/query-keys";
import { MissingSupabaseConfigError } from "@/lib/supabase/env";

export function useCurrentUser() {
  return useQuery({
    queryKey: queryKeys.currentUser,
    queryFn: getCurrentUser,
    retry: (failureCount, error) =>
      error instanceof MissingSupabaseConfigError ? false : failureCount < 1,
  });
}

export function useMyCommunities(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.myCommunities,
    queryFn: getMyCommunities,
    enabled,
  });
}
